import React from "react";
import { useSelector } from "react-redux";
import FlexLayout from "../../controls/FlexLayout";
import { useSwitchingProfile } from "../../hooks";
import { WindowControls } from "../WindowControls";
import { DialogLayer } from "./DialogLayer";
import { LayoutContainer } from "./LayoutContainer";
import { MainLayout } from "./MainLayout";
import { ProfileSwitcher } from "./ProfileSwitcher";
import { ToastContainer } from "./ToastContainer";
import { Toolbar } from "./Toolbar";
import { UIBlocker } from "./UIBlocker";
export const ClassicLayout = () => {
    const customTitlebar = useSelector((state) => state.settings.window.customTitlebar);
    const switchingProfile = useSwitchingProfile();
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContainer, null,
            React.createElement(FlexLayout, { id: "main-window-content", type: "column" },
                React.createElement(Toolbar, null),
                customTitlebar ? React.createElement("div", { className: "dragbar" }) : null,
                switchingProfile ? React.createElement(ProfileSwitcher, null) : React.createElement(MainLayout, null)),
            React.createElement(DialogLayer, null),
            React.createElement(ToastContainer, null),
            customTitlebar ? React.createElement(WindowControls, null) : null),
        React.createElement(UIBlocker, null)));
};
